import { Circle } from "./Circle";
import { Hexagon } from "./Hexagon";
import { Star8 } from "./Star8";
import { Diamond } from "./Diamond";
import { BlobbyStar } from "./BlobbyStar";
import { Heart } from "./Heart";
import { Club } from "./Club";
import { Spade } from "./Spade";
import { ShapeProps } from "./types";

export const getShapeComponent = (shape: string): React.FC<ShapeProps> => {
  switch (shape) {
    case "hexagon":
      return Hexagon;
    case "star-8":
      return Star8;
    case "diamond":
      return Diamond;
    case "blobby-star":
      return BlobbyStar;
    case "heart":
      return Heart;
    case "club":
      return Club;
    case "spade":
      return Spade;
    case "circle":
    default:
      return Circle;
  }
};
